import React from 'react';
import ReactMarkdown from 'react-markdown';

export default class Alert extends React.Component {
  render() {
    return (
      <div className="alert alert-info" style={this.props.style}>
        <i className="fa fa-lightbulb fa-2x pull-left" />
        <ReactMarkdown source={this.props.alert} />
      </div>
    );
  }
}
